import React, { FC, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useGroupComparison } from '../../../hooks';
import { useOutOfElDetection } from '../../../hooks/useOutOfElDetection';
import SearchStaticHeader from '../../SearchDropdown/SearchStaticHeader/SearchStaticHeader';
import { IFilterMultiselectDataEl } from '../CompareSortFilter';
import {
  ApplyButton,
  ClearAllButton,
  CompareBodyCont,
  CompareFilterCont,
  CTAButtonsCont
} from './CompareFilter.styles';
import CompareFilterMultiselect from './CompareFilterMultiselect/CompareFilterMultiselect';

interface ICompareFilter {
  selectedItemsCount: number;
  searchForTeam: (phrase: string) => void;
  teamsList: IFilterMultiselectDataEl[] | any;
  manageTeamSelection: (val: string) => void;
  manageRiskSelection: (val: string) => void;
  teamFiltersSelected: string[];
  riskFiltersSelected: string[];
  clearFilters: (group: string, initFunc: boolean) => void;
  applyTeamListFilters: (val: MouseEvent | any) => void;
  highlighted?: boolean;
  noRisk?: boolean;
}
const CompareFilter:FC<ICompareFilter> = ({
  selectedItemsCount,
  searchForTeam,
  teamsList,
  manageTeamSelection,
  teamFiltersSelected,
  manageRiskSelection,
  riskFiltersSelected,
  clearFilters,
  applyTeamListFilters,
  highlighted,
  noRisk,
}) => {
  const dropRef = useRef(null);
  const [active, setActive] = useState(false);
  const {t} = useTranslation();
  const {riskTypesArr} = useGroupComparison();

  const setDropActive = async (state: boolean) => {
    await searchForTeam('');
    setActive(state);
  };
  const closeDrop = () => {
    setActive(false);
  };
  useOutOfElDetection(dropRef, closeDrop);
  const selectedCountTitle = selectedItemsCount > 0 ? `${selectedItemsCount} Selected` : '';


  const applyFilters = (e: MouseEvent | any) => {
    applyTeamListFilters(e);
    setActive(false);
  };
  return (<CompareFilterCont
    id="CompareFilterCont"
    ref={dropRef}
  >
    <SearchStaticHeader
      label={t('report.groupComparison.filterBy')}
      data-testid="StaticDrophead"
      active={active}
      placeholder={t('report.groupComparison.filterByTeamOrRisk')}
      setActive={setDropActive}
      width="320px"
      activeEl={selectedCountTitle}
      clearAction={() => clearFilters('compare', true)}
      highlighted={highlighted && !active}
    />
    {active && (<CompareBodyCont id="CompareBodyCont">
      <CompareFilterMultiselect
        name={t('report.groupComparison.teamName')}
        searchMethod={searchForTeam}
        data={teamsList}
        setSelected={manageTeamSelection}
        selectedArr={teamFiltersSelected}
      />
      {!noRisk && (<CompareFilterMultiselect
        name={t('report.groupComparison.risk')}
        data={riskTypesArr}
        setSelected={manageRiskSelection}
        selectedArr={riskFiltersSelected}
      />)}
      <CTAButtonsCont id="CTAButtonsCont">
        <ClearAllButton
          data-testid="ClearAllButton"
          onClick={() => clearFilters('compare', true)}
        >
          {t('report.groupComparison.clearAll')}
        </ClearAllButton>
        <ApplyButton
          data-testid="ApplyButton"
          onClick={applyFilters}
        >
          {t('report.groupComparison.apply')}
        </ApplyButton>
      </CTAButtonsCont>
    </CompareBodyCont>)}
  </CompareFilterCont>);
};

export default CompareFilter;
